// Service pages configuration — 7 SEO-optimized pages
// Each config drives the generic ServicePage component

export const SERVICE_CONFIGS = {
  mecanique: {
    slug: 'mecanique',
    route: '/garage-meyrin/mecanique',
    heroTitle: 'Entretien & Mécanique',
    heroAccent: 'à Meyrin',
    heroSubtitle: 'Garage moderne pour vos véhicules essence, diesel, hybride ou électrique — toutes marques.',
    h1: 'Mécanique générale à Meyrin — Entretien & Réparation',
    srOnlyH2: 'Garage mécanique à Meyrin (1217) — vidange, révision, freins et distribution toutes marques à Genève, Vernier, Grand-Saconnex et Châtelaine',
    metaTitle: 'Mécanique Auto Meyrin | Révision, Vidange, Freins — CarMaintenance',
    metaDesc: 'Service mécanique complet à Meyrin (1217 Genève). Vidange, révision, freins, distribution, embrayage. Devis gratuit, prise de RDV en ligne.',
    keywords: 'mécanique meyrin, garage meyrin, vidange meyrin, révision auto genève, freins meyrin, distribution voiture',
    introTitle: 'Votre garage de confiance à Meyrin',
    introBody: "Chez CarMaintenance Meyrin, nous prenons soin de votre voiture comme si c'était la nôtre. Avec un équipement moderne, des techniciens certifiés UPSA et l'accès aux données constructeurs, notre atelier intervient sur toutes les marques européennes, japonaises et américaines. Vidange, révision, freins, courroie de distribution, embrayage : chaque intervention est accompagnée d'un devis transparent envoyé par SMS avant tout travail.",
    bullets: [
      { title: 'Vidange & filtres', desc: 'Huile constructeur + filtre OEM inclus' },
      { title: 'Freins & disques', desc: 'Plaquettes et disques sous garantie' },
      { title: 'Distribution', desc: 'Kit complet + pompe à eau' },
      { title: 'Embrayage', desc: 'Kit + volant moteur si nécessaire' },
    ],
    whyChoose: [
      'Garage agréé UPSA & Garage Plus',
      'Aucun travail sans accord client',
      'Devis transparent par SMS',
      'Abonnement dès 39 CHF/mois disponible',
    ],
    pricingTitle: 'Nos forfaits entretien',
    pricing: [
      { title: 'Service Petit Entretien', desc: 'Vidange huile + filtres (huile, air, habitacle)', price: 'Dès 189', popular: false },
      { title: 'Service Complet', desc: 'Vidange + filtres + révision multipoints, liquide de frein, contrôle complet', price: 'Dès 390', popular: true },
      { title: 'Plaquettes de freins', desc: 'Avant ou arrière — pose comprise', price: 'Dès 250', popular: false },
      { title: 'Kit de distribution', desc: 'Courroie + galet + pompe à eau', price: 'Dès 890', popular: false },
      { title: 'Embrayage complet', desc: 'Kit + volant moteur si nécessaire', price: 'Dès 1200', popular: false },
      { title: 'Diagnostic pré-achat', desc: 'Inspection complète avant achat', price: '150', popular: false },
    ],
    contentSections: [
      {
        h2: 'L\u2019entretien préventif : un investissement, pas une dépense',
        body: 'Un entretien régulier prolonge la vie de votre moteur et préserve la valeur de votre véhicule à la revente. Notre approche connectée vous envoie une notification dès qu\u2019une intervention est recommandée, basée sur le kilométrage et le carnet d\u2019entretien constructeur. Vous n\u2019oubliez plus jamais une vidange et restez couvert par votre garantie.',
      },
      {
        h2: 'Toutes marques, toutes motorisations',
        body: 'Audi, BMW, Mercedes, Peugeot, Renault, Volkswagen, Toyota, Tesla, hybrides et 100% électriques : nos techniciens sont formés sur l\u2019ensemble des technologies actuelles. Nous disposons des outils de diagnostic constructeurs et accédons aux mises à jour des calculateurs en temps réel.',
      },
    ],
    faq: [
      { q: 'Tous les combien faire une vidange ?', a: 'Tous les 15 000 à 30 000 km selon le constructeur, ou une fois par an. Notre système connecté vous alerte automatiquement.' },
      { q: 'Quels sont vos délais ?', a: 'Une vidange prend environ 1h. Pour une révision complète, comptez une demi-journée. Véhicule de remplacement disponible.' },
      { q: 'Acceptez-vous les véhicules hybrides et électriques ?', a: 'Oui, nos techniciens sont certifiés pour intervenir sur tous les types de motorisations, y compris haute tension.' },
    ],
    formTitle: 'Demandez votre devis gratuit',
  },

  diagnostic: {
    slug: 'diagnostic',
    route: '/garage-meyrin/diagnostic',
    heroTitle: 'Diagnostic Auto',
    heroAccent: 'à Meyrin',
    heroSubtitle: 'Lecture OBD, recherche de panne électronique, codage. Meyrin (1217), Genève. Diagnostic dernière génération.',
    h1: 'Diagnostic Électronique Auto à Meyrin',
    srOnlyH2: 'Diagnostic voiture à Meyrin & Genève — lecture OBD, effacement voyant moteur, codage BMW Audi VW Mercedes à 1217 Meyrin',
    metaTitle: 'Diagnostic Auto Meyrin | Lecture défauts, Codage — CarMaintenance',
    metaDesc: 'Diagnostic électronique professionnel à Meyrin. Lecture codes défaut, effacement voyants, codage et programmation calculateur. Toutes marques.',
    keywords: 'diagnostic auto meyrin, lecture OBD genève, codage voiture meyrin, voyant moteur genève, reprogrammation calculateur',
    introTitle: 'Diagnostic électronique professionnel à Meyrin',
    introBody: "Voyant moteur allumé ? Comportement étrange ? Notre équipement professionnel lit l\u2019ensemble des calculateurs de votre véhicule en quelques minutes et identifie l\u2019origine exacte du problème. Nos techniciens vous remettent un rapport écrit avec les codes défaut, leur explication et les solutions recommandées. Aucune intervention sans votre accord.",
    bullets: [
      { title: 'Lecture multi-marques', desc: 'OBD-II + outils constructeurs' },
      { title: 'Effacement voyants', desc: 'Après correction du défaut' },
      { title: 'Codage avancé', desc: 'Options, mises à jour, BMW/VAG' },
      { title: 'Test sur route', desc: 'Vérification réelle après intervention' },
    ],
    whyChoose: [
      'Rapport écrit envoyé par SMS',
      'Techniciens certifiés',
      'Toutes marques et modèles',
      'Devis avant intervention',
    ],
    pricingTitle: 'Nos tarifs diagnostic',
    pricing: [
      { title: 'Lecture Codes Défaut', desc: 'Scan complet tous calculateurs', price: '80', popular: false },
      { title: 'Diagnostic Approfondi', desc: 'Analyse multi-systèmes, rapport écrit + recommandations', price: '150', popular: true },
      { title: 'Effacement Voyants', desc: 'Reset après correction du défaut', price: '60', popular: false },
      { title: 'Codage & Programmation', desc: 'Activation options, mise à jour calculateur', price: 'Dès 250', popular: false },
    ],
    contentSections: [
      {
        h2: 'Quand prendre rendez-vous pour un diagnostic ?',
        body: 'Voyant moteur allumé, perte de puissance, démarrage difficile, consommation anormale, ABS/ESP en alerte, climatisation défaillante : tous ces signes méritent un diagnostic électronique avant qu\u2019une panne plus coûteuse n\u2019apparaisse. Plus tôt vous venez, moins l\u2019intervention sera onéreuse.',
      },
      {
        h2: 'Notre méthode',
        body: 'Nous combinons des outils universels (OBD-II) et les valises constructeurs (VAG-COM, BMW ISTA, MB Star, etc.) pour accéder aux données complètes : calculateur moteur, ABS, airbag, transmission, climatisation. Le diagnostic est suivi d\u2019un test sur route pour valider la correction.',
      },
    ],
    faq: [
      { q: 'Pourquoi un voyant moteur s\u2019allume ?', a: 'Capteur défectueux, mélange air/carburant, FAP saturé, vanne EGR encrassée... Un diagnostic permet de cibler la cause précise.' },
      { q: 'Le voyant s\u2019éteint tout seul, dois-je m\u2019inquiéter ?', a: 'Oui, le défaut reste enregistré dans la mémoire du calculateur. Il faut le lire pour anticiper une panne.' },
      { q: 'Codage VAG ou BMW : vous le faites ?', a: 'Oui, codage avancé sur Audi, VW, BMW, Mercedes — activations d\u2019options, mises à jour calculateur, immobilisation.' },
    ],
    formTitle: 'Demandez votre diagnostic',
  },

  pneus: {
    slug: 'pneus',
    route: '/garage-meyrin/pneus',
    heroTitle: 'Pneus & Géométrie',
    heroAccent: 'à Meyrin',
    heroSubtitle: 'Montage, équilibrage, parallélisme, stockage saisonnier. Pneus premium toutes marques.',
    h1: 'Pneus & Jantes à Meyrin — Montage, Équilibrage, Stockage',
    srOnlyH2: 'Centre pneus Meyrin — pneus hiver, été et 4 saisons, géométrie 3D, gardiennage saisonnier à Genève, Vernier et Grand-Saconnex',
    metaTitle: 'Pneus Meyrin | Montage, Équilibrage, Stockage — CarMaintenance',
    metaDesc: 'Centre pneus à Meyrin. Montage, équilibrage, permutation, géométrie 3D, stockage saisonnier sécurisé. Pneus recommandés TCS.',
    keywords: 'pneus meyrin, géométrie meyrin, équilibrage genève, stockage pneus meyrin, parallélisme auto, pneus hiver genève',
    introTitle: 'Meyrin — pneumatique complet & géométrie',
    introBody: "Pneus hiver, été, 4 saisons : nous vous accompagnons toute l\u2019année dans le choix et l\u2019entretien de vos pneumatiques. Au-delà du simple montage, notre banc de géométrie 3D dernière génération corrige le parallélisme et le carrossage de votre véhicule, prolongeant la durée de vie de vos pneus et améliorant votre sécurité.",
    bullets: [
      { title: 'Montage & équilibrage', desc: 'Sur jante alu ou acier' },
      { title: 'Géométrie 3D', desc: 'Précision millimétrique' },
      { title: 'Stockage saisonnier', desc: 'Stockage sécurisé climatisé' },
      { title: 'Toutes les marques', desc: 'Michelin, Continental, Bridgestone, Pirelli...' },
    ],
    whyChoose: [
      'Pneumatique recommandé TCS',
      'Banc géométrie 3D',
      'Stockage sécurisé',
      'Pneus premium au juste prix',
    ],
    pricingTitle: 'Nos tarifs pneus & géométrie',
    pricing: [
      { title: 'Remplacement 4 roues', desc: 'Démontage des roues + remontage', price: '50', popular: false },
      { title: 'Permutation 4 pneus 15-16"', desc: 'Démontage + remontage saisonnier', price: '80', popular: false },
      { title: 'Permutation 4 pneus 17-18"', desc: 'Démontage + remontage saisonnier', price: '90', popular: true },
      { title: 'Permutation 4 pneus 19-24"', desc: 'Démontage + remontage saisonnier', price: '100', popular: false },
      { title: 'Géométrie', desc: 'Banc de géométrie dernière génération', price: '139', popular: false },
      { title: 'Gardiennage', desc: 'Stockage saisonnier sécurisé', price: '80/saison', popular: false },
      { title: 'Réparation crevaison', desc: 'Si réparable selon norme', price: '35', popular: false },
    ],
    contentSections: [
      {
        h2: 'Résultats TCS Pneu Test 2024-2026',
        body: 'Nous vous conseillons à partir des derniers tests TCS. Les meilleures notes 2024 : Michelin CrossClimate 2 (été), Continental WinterContact TS 870 (hiver), Continental AllSeasonContact 2 (4 saisons). En 2025, Goodyear Vector 4Seasons Gen-3 et Pirelli Cinturato All Season SF2 ont dominé la catégorie 4 saisons. Pour 2026, Bridgestone Turanza All Season 6 confirme la tendance des pneus toutes saisons premium.',
      },
      {
        h2: 'Quand changer ses pneus ?',
        body: 'Profondeur de sculpture inférieure à 3 mm, plus de 6 ans d\u2019âge, déformations ou hernies visibles, freinage allongé sur sol mouillé. Nos techniciens vérifient gratuitement vos pneus à chaque passage.',
      },
    ],
    faq: [
      { q: 'Pneus 4 saisons ou hiver + été ?', a: 'À Genève, les pneus 4 saisons modernes (note A+ TCS) suffisent pour la plupart des conducteurs. Pour ceux qui font du ski régulièrement, les pneus hiver dédiés restent plus performants.' },
      { q: 'Stockage : combien ça coûte ?', a: '120 CHF / 6 mois, dans notre dépôt sécurisé et climatisé. Vous ne stockez plus dans votre cave.' },
      { q: 'La géométrie c\u2019est obligatoire ?', a: 'Après un choc, le remplacement de pneus, ou si vous notez une usure asymétrique. Vivement recommandé tous les 30 000 km.' },
    ],
    formTitle: 'Demandez votre devis pneus',
    specialSection: { type: 'tcs' },
  },

  climatisation: {
    slug: 'climatisation',
    route: '/garage-meyrin/climatisation',
    heroTitle: 'Climatisation Auto',
    heroAccent: 'à Meyrin',
    heroSubtitle: 'Recharge, anti-allergie, détection de fuites, désinfection. Véhicules R134a et R1234yf.',
    h1: 'Climatisation Auto à Meyrin — Recharge & Réparation',
    srOnlyH2: 'Recharge climatisation voiture Meyrin — gaz R134a et R1234yf, détection fuites, désinfection à 1217 Meyrin près de Genève',
    metaTitle: 'Climatisation Auto Meyrin | Recharge, Entretien Clim — CarMaintenance',
    metaDesc: 'Entretien climatisation automobile à Meyrin. Recharge gaz R134a et R1234yf, détection fuites azote, désinfection circuit.',
    keywords: 'climatisation meyrin, recharge clim genève, R1234yf meyrin, fuite climatisation, désinfection clim',
    introTitle: 'Entretien climatisation professionnel',
    introBody: "La climatisation de votre voiture perd naturellement de son efficacité chaque année. Recharger le gaz, désinfecter le circuit et détecter d\u2019éventuelles fuites prolonge la durée de vie de votre système et préserve votre santé. Nos stations dernière génération sont compatibles avec les véhicules récents (R1234yf) comme les véhicules plus anciens (R134a).",
    bullets: [
      { title: 'Recharge R134a / R1234yf', desc: 'Station automatique de précision' },
      { title: 'Détection de fuite azote', desc: 'Précision maximum' },
      { title: 'Désinfection', desc: 'Élimination des bactéries' },
      { title: 'Diagnostic complet', desc: 'Compresseur, condenseur, capteurs' },
    ],
    whyChoose: [
      'Station de recharge automatique',
      'R134a + R1234yf inclus',
      'Test étanchéité',
      'Garantie 12 mois',
    ],
    pricingTitle: 'Nos tarifs climatisation',
    pricing: [
      { title: 'Recharge Clim R134A', desc: 'Vide complet, test étanchéité, remplissage conforme', price: '99.-', popular: false },
      { title: 'Recharge Clim R1234YF', desc: 'Pour véhicules récents, recharge + diagnostic + test', price: '199.-', popular: true },
      { title: 'Désinfection circuit', desc: 'Élimination antibactérienne du circuit', price: '89', popular: false },
      { title: 'Détection fuite azote', desc: 'Méthode azote sous pression, précision maximum', price: '149.-', popular: false },
      { title: 'Compresseur (remplacement)', desc: 'Pièce + main d\u2019œuvre', price: 'Sur devis', popular: false },
    ],
    contentSections: [
      {
        h2: 'Pourquoi recharger sa climatisation ?',
        body: 'Un système de climatisation perd environ 10% de gaz par an, même sans fuite. Sans recharge régulière, le froid diminue, le compresseur force et finit par tomber en panne — une réparation à plusieurs centaines de francs. Une recharge tous les 2 à 3 ans suffit à préserver le confort et la durée de vie de votre clim.',
      },
      {
        h2: 'Désinfection : pourquoi c\u2019est important',
        body: 'L\u2019évaporateur et les conduits accumulent humidité, poussière et bactéries. Résultat : mauvaises odeurs, allergies, problèmes respiratoires. Notre désinfection à ultrasons élimine 99,9% des micro-organismes en moins de 30 minutes.',
      },
    ],
    faq: [
      { q: 'À quelle fréquence recharger sa clim ?', a: 'Tous les 2 à 3 ans pour un fonctionnement optimal. Si le froid devient tiède, c\u2019est qu\u2019il est temps.' },
      { q: 'Mon véhicule est récent, est-ce du R1234yf ?', a: 'Tous les véhicules immatriculés après 2017 utilisent le R1234yf. Nous gérons les deux gaz.' },
      { q: 'Combien de temps pour une recharge ?', a: 'Environ 45 minutes, vous pouvez attendre dans notre espace café.' },
    ],
    formTitle: 'Demandez votre devis climatisation',
  },

  expertise: {
    slug: 'expertise',
    route: '/garage-meyrin/expertise',
    heroTitle: 'Préparation & Expertise',
    heroAccent: 'à Meyrin',
    heroSubtitle: 'Préparation au contrôle technique, pré-contrôle, corrections avant passage. 95% de réussite au premier coup.',
    h1: 'Expertise & Contrôle Technique à Meyrin',
    srOnlyH2: 'Préparation expertise voiture Meyrin — contrôle technique SAN Genève, contre-visite, expertise pré-achat à 1217 Meyrin',
    metaTitle: 'Expertise Auto Meyrin | Contrôle Technique, Sinistre — CarMaintenance',
    metaDesc: 'Expertise automobile professionnelle à Meyrin. Préparation au contrôle technique (SAN), expertise pré-achat, rapport assurance.',
    keywords: 'expertise auto meyrin, contrôle technique genève, SAN meyrin, pré-achat voiture, expertise assurance',
    introTitle: 'Préparez votre contrôle technique sereinement',
    introBody: "Le contrôle technique (SAN à Genève) peut être source de stress. Chez CarMaintenance Meyrin, nous préparons votre véhicule pour qu\u2019il passe sans souci : freins, suspension, direction, éclairage, émissions. Si des défauts sont détectés, nous vous envoyons un devis transparent avant correction. Notre taux de réussite : 95% au premier passage.",
    bullets: [
      { title: 'Pré-contrôle complet', desc: 'Simulation au passage SAN' },
      { title: 'Corrections rapides', desc: 'Réparations sur le moment' },
      { title: '95% de réussite', desc: 'Sur nos clients préparés' },
      { title: 'Rapport SMS', desc: 'Devis transparent envoyé' },
    ],
    whyChoose: [
      '95% de taux de réussite',
      'Pré-contrôle 99 CHF',
      'Corrections le jour même',
      'Devis transparent SMS',
    ],
    pricingTitle: 'Nos tarifs',
    pricing: [
      { title: 'Préparation pour contrôle SAN', desc: 'Inspection complète simulant le passage SAN, lavage châssis-moteur, correction position des phares, corrections incluses, rapport des points vérifiés', price: '199', popular: false },
      { title: 'Préparation + Présentation', desc: 'Préparation complète + présentation au centre SAN', price: '299', popular: true },
      { title: 'Préparation contre-visite', desc: 'Corrections après échec au SAN — sur la base de votre rapport', price: 'Sur devis', popular: false },
    ],
    contentSections: [
      {
        h2: 'Que vérifie-t-on lors d\u2019un pré-contrôle ?',
        body: 'Système de freinage, direction, suspension, pneumatiques, éclairage avant et arrière, signalisation, émissions, niveaux, jeu dans les rotules et silentblocs. Bref, tout ce que le centre SAN vérifiera. Si un défaut est détecté, nous vous proposons une correction immédiate avec devis avant tout travail.',
      },
      {
        h2: 'Expertise pré-achat : sécurisez votre prochain véhicule',
        body: 'Avant d\u2019acheter une voiture d\u2019occasion, faites-la examiner par nos experts indépendants. Nous vérifions 50 points clés : moteur, transmission, châssis, électronique, kilométrage réel, historique d\u2019entretien. Vous recevez un rapport écrit qui peut servir à négocier le prix.',
      },
    ],
    faq: [
      { q: 'Combien de temps avant le SAN pour préparer ?', a: 'Idéalement 1 semaine avant, pour avoir le temps de corriger les défauts éventuels.' },
      { q: 'Vous présentez au SAN ?', a: 'Oui, forfait "Préparation + Présentation" à 299 CHF : on s\u2019occupe de tout, vous récupérez votre véhicule contrôlé.' },
      { q: 'Et si le contrôle échoue malgré la préparation ?', a: 'Nous corrigeons gratuitement les défauts mentionnés par le SAN (sous 30 jours) sans frais supplémentaires de main d\u2019œuvre.' },
    ],
    formTitle: 'Réservez votre pré-contrôle',
    quickDevisWhatsapp: {
      title: 'Devis contre-visite en quelques minutes',
      desc: 'Envoyez-nous votre rapport du SAN en photos sur WhatsApp et vous recevrez un devis rapidement.',
      message: 'Bonjour, je souhaiterai un devis de Préparation contre-visite.',
    },
  },

  carrosserie: {
    slug: 'carrosserie',
    route: '/garage-meyrin/carrosserie',
    heroTitle: 'Carrosserie & Peinture',
    heroAccent: 'à Meyrin',
    heroSubtitle: 'Réparation chocs, peinture haute qualité, débosselage sans peinture, polissage. Agréé toutes assurances.',
    h1: 'Carrosserie & Peinture Auto à Meyrin',
    srOnlyH2: 'Carrosserie & peinture auto à Meyrin — réparation choc, débosselage sans peinture PDR, agréé toutes assurances à Genève',
    metaTitle: 'Carrosserie Meyrin | Réparation, Peinture, Débosselage — CarMaintenance',
    metaDesc: 'Atelier carrosserie à Meyrin. Réparation chocs, peinture, débosselage sans peinture (PDR), polissage. Agréé toutes assurances.',
    keywords: 'carrosserie meyrin, peinture auto genève, débosselage meyrin, accident voiture genève, assurance carrosserie',
    introTitle: 'Carrosserie & peinture haut de gamme à Meyrin',
    introBody: "Choc, rayure, bosse, sinistre majeur : notre atelier carrosserie remet votre véhicule à neuf. Nous travaillons avec toutes les compagnies d\u2019assurance (RC, casco) et prenons en charge l\u2019intégralité du dossier. Notre cabine de peinture neuve garantit des teintes parfaitement assorties, sur toutes les marques.",
    bullets: [
      { title: 'Débosselage sans peinture (PDR)', desc: 'Pour les petites bosses sans rayure' },
      { title: 'Peinture cabine neuve', desc: 'Teintes constructeur exactes' },
      { title: 'Polissage complet', desc: 'Correction & protection céramique' },
      { title: 'Gestion assurance', desc: 'Dossier traité de A à Z' },
    ],
    whyChoose: [
      'Agréé toutes assurances',
      'Cabine de peinture neuve',
      'Véhicule de remplacement',
      'Garantie peinture 5 ans',
    ],
    pricingTitle: 'Nos tarifs carrosserie',
    pricing: [
      { title: 'Débosselage sans Peinture', desc: 'PDR — petites bosses sans rayure', price: 'Dès 150', popular: false },
      { title: 'Peinture Élément', desc: 'Préparation + peinture + vernis', price: 'Dès 450', popular: true },
      { title: 'Réparation Pare-Chocs', desc: 'Réparation plastique + peinture', price: 'Dès 350', popular: false },
      { title: 'Polissage Complet', desc: 'Correction peinture + protection', price: 'Dès 280', popular: false },
      { title: 'Prise en Charge Assurance', desc: 'Gestion directe avec assurance', price: 'Sur devis', popular: false },
    ],
    contentSections: [
      {
        h2: 'Sinistre : on s\u2019occupe de tout',
        body: 'En cas d\u2019accident, vous n\u2019avez rien à gérer. Nous remplissons le constat avec vous, contactons votre assurance, négocions l\u2019expertise, fournissons un véhicule de remplacement le temps des réparations. Notre objectif : que vous repartiez avec votre voiture comme neuve, sans avoir à courir après personne.',
      },
      {
        h2: 'Toutes assurances acceptées',
        body: 'AXA, Allianz, Helvetia, La Mobilière, Generali, Zurich, Vaudoise, TCS, Smile : nous travaillons directement avec votre compagnie. Pas d\u2019avance de frais (hors franchise éventuelle), facture envoyée directement à l\u2019assurance.',
      },
    ],
    faq: [
      { q: 'Combien de temps pour réparer un choc ?', a: 'Petit choc : 1 à 3 jours. Sinistre moyen : 1 semaine. Gros sinistre : 2 à 3 semaines selon les pièces.' },
      { q: 'Vous prêtez un véhicule ?', a: 'Oui, véhicule de remplacement inclus pour tout sinistre pris en charge par l\u2019assurance.' },
      { q: 'Mon véhicule est ancien, ça vaut le coup ?', a: 'Nous évaluons gratuitement la valeur du véhicule et le coût des réparations avant tout engagement.' },
    ],
    formTitle: 'Demandez votre devis carrosserie',
    quickDevisWhatsapp: {
      title: 'Devis en quelques minutes',
      desc: 'Envoyez votre carte grise et des photos des travaux sur WhatsApp — on revient vers vous très rapidement avec une estimation.',
      message: 'Bonjour, je souhaiterai un devis de Carrosserie.',
    },
    specialSection: { type: 'emergency' },
  },

  'boites-vitesses': {
    slug: 'boites-vitesses',
    route: '/garage-meyrin/boites-vitesses',
    heroTitle: 'Boîtes de Vitesses',
    heroAccent: 'à Meyrin',
    heroSubtitle: 'Réparation BVM et BVA, vidange transmission automatique, diagnostic spécialisé. Toutes marques.',
    h1: 'Réparation Boîte de Vitesses à Meyrin',
    srOnlyH2: 'Spécialiste boîte de vitesses Meyrin — vidange BVA, DSG, S-Tronic, PDK et embrayage à 1217 Meyrin près de Genève',
    metaTitle: 'Boîte de Vitesses Meyrin | Réparation BVM/BVA — CarMaintenance',
    metaDesc: 'Spécialiste boîte de vitesses à Meyrin. Réparation BVM/BVA, vidange ATF, embrayage. Diagnostic spécialisé toutes marques.',
    keywords: 'boite vitesses meyrin, réparation BVA genève, embrayage meyrin, vidange ATF, transmission auto',
    introTitle: 'Spécialiste boîte de vitesses à Meyrin',
    introBody: "Boîte manuelle (BVM) ou boîte automatique (BVA) : notre atelier intervient sur tous les types de transmissions, y compris les boîtes à double embrayage (DSG, PDK, S-Tronic). Vidange ATF préventive, remplacement d\u2019embrayage, diagnostic spécialisé, reprogrammation : nos techniciens disposent des outils dédiés aux principales marques européennes.",
    bullets: [
      { title: 'Vidange BVM & BVA', desc: 'Huile ATF + filtre + joints' },
      { title: 'Diagnostic spécialisé', desc: 'BVA, DSG, PDK, S-Tronic' },
      { title: 'Embrayage complet', desc: 'Kit + volant moteur' },
      { title: 'Reprogrammation', desc: 'Mise à jour calculateur transmission' },
    ],
    whyChoose: [
      'Spécialiste BVA toutes marques',
      'Outillage constructeur',
      'Vidange préventive recommandée',
      'Diagnostic + essai route inclus',
    ],
    pricingTitle: 'Nos tarifs boîtes de vitesses',
    pricing: [
      { title: 'Vidange BVM', desc: 'Huile transmission manuelle', price: 'Dès 150', popular: false },
      { title: 'Vidange BVA', desc: 'Huile ATF + filtre + joints', price: 'Dès 280', popular: true, whatsappMessage: 'Bonjour, je souhaiterai un devis pour une vidange BVA.' },
      { title: 'Diagnostic BVA', desc: 'Lecture défauts + essai route', price: '150', popular: false },
      { title: 'Embrayage, volant moteur, kit complet', desc: 'Remplacement complet selon véhicule', price: 'Sur devis', popular: false, whatsappMessage: 'Bonjour, je souhaiterai un devis pour un embrayage / volant moteur / kit complet.' },
      { title: 'Échange standard', desc: 'Selon état et modèle', price: 'Sur devis', popular: false, whatsappMessage: 'Bonjour, je souhaiterai un devis pour un échange standard de boîte de vitesses.' },
    ],
    contentSections: [
      {
        h2: 'Pourquoi entretenir sa boîte automatique ?',
        body: 'Contrairement à ce que disent certains constructeurs, l\u2019huile de boîte automatique n\u2019est pas "à vie". Au-delà de 80 000 km, elle perd ses propriétés lubrifiantes et peut endommager les solénoïdes et le convertisseur. Une vidange préventive tous les 60 000 km évite des réparations à plusieurs milliers de francs.',
      },
      {
        h2: 'Embrayage qui patine ?',
        body: 'Si vous sentez votre voiture moins reprendre malgré les gros gaz, ou si l\u2019odeur de brûlé apparaît à chaud, votre embrayage donne des signes de faiblesse. Mieux vaut le remplacer avant qu\u2019il ne casse en pleine circulation. Nous remplaçons le kit complet (disque + mécanisme + butée + volant moteur si nécessaire).',
      },
    ],
    faq: [
      { q: 'Tous les combien faire la vidange BVA ?', a: 'Recommandé tous les 60 000 km, malgré ce que disent certains constructeurs ("huile à vie"). Préventif est moins cher que curatif.' },
      { q: 'Vous faites les boîtes DSG / S-Tronic ?', a: 'Oui, nous disposons des outils constructeur VAG pour intervenir sur les boîtes à double embrayage.' },
      { q: 'Embrayage : combien de temps ça dure ?', a: 'Entre 100 000 et 200 000 km selon le style de conduite. Une conduite calme en ville prolonge sa vie.' },
    ],
    formTitle: 'Demandez votre devis transmission',
  },
};

export const SERVICE_LIST = Object.values(SERVICE_CONFIGS).map(c => ({
  slug: c.slug,
  route: c.route,
  title: c.heroTitle,
}));
